"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldDataTypeEnum;
(function (TableauNlpSemanticmodelFieldDataTypeEnum) {
    TableauNlpSemanticmodelFieldDataTypeEnum["Unspecified"] = "DATATYPE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldDataTypeEnum["Date"] = "DATATYPE_DATE";
    TableauNlpSemanticmodelFieldDataTypeEnum["Datetime"] = "DATATYPE_DATETIME";
    TableauNlpSemanticmodelFieldDataTypeEnum["Number"] = "DATATYPE_NUMBER";
    TableauNlpSemanticmodelFieldDataTypeEnum["Boolean"] = "DATATYPE_BOOLEAN";
    TableauNlpSemanticmodelFieldDataTypeEnum["Text"] = "DATATYPE_TEXT";
    TableauNlpSemanticmodelFieldDataTypeEnum["None"] = "DATATYPE_NONE";
    TableauNlpSemanticmodelFieldDataTypeEnum["Spatial"] = "DATATYPE_SPATIAL";
    TableauNlpSemanticmodelFieldDataTypeEnum["Table"] = "DATATYPE_TABLE";
})(TableauNlpSemanticmodelFieldDataTypeEnum = exports.TableauNlpSemanticmodelFieldDataTypeEnum || (exports.TableauNlpSemanticmodelFieldDataTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldFieldTypeEnum;
(function (TableauNlpSemanticmodelFieldFieldTypeEnum) {
    TableauNlpSemanticmodelFieldFieldTypeEnum["Unspecified"] = "FIELDTYPE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Calculatedfield"] = "FIELDTYPE_CALCULATEDFIELD";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Columnfield"] = "FIELDTYPE_COLUMNFIELD";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Groupfield"] = "FIELDTYPE_GROUPFIELD";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Hierarchicalfield"] = "FIELDTYPE_HIERARCHICALFIELD";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Setfield"] = "FIELDTYPE_SETFIELD";
    TableauNlpSemanticmodelFieldFieldTypeEnum["Binfield"] = "FIELDTYPE_BINFIELD";
})(TableauNlpSemanticmodelFieldFieldTypeEnum = exports.TableauNlpSemanticmodelFieldFieldTypeEnum || (exports.TableauNlpSemanticmodelFieldFieldTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldFieldRoleEnum;
(function (TableauNlpSemanticmodelFieldFieldRoleEnum) {
    TableauNlpSemanticmodelFieldFieldRoleEnum["Unspecified"] = "FIELDROLE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldFieldRoleEnum["Dimension"] = "FIELDROLE_DIMENSION";
    TableauNlpSemanticmodelFieldFieldRoleEnum["Measure"] = "FIELDROLE_MEASURE";
})(TableauNlpSemanticmodelFieldFieldRoleEnum = exports.TableauNlpSemanticmodelFieldFieldRoleEnum || (exports.TableauNlpSemanticmodelFieldFieldRoleEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldDataRangeTypeEnum;
(function (TableauNlpSemanticmodelFieldDataRangeTypeEnum) {
    TableauNlpSemanticmodelFieldDataRangeTypeEnum["Unspecified"] = "DATARANGETYPE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldDataRangeTypeEnum["Quantitative"] = "DATARANGETYPE_QUANTITATIVE";
    TableauNlpSemanticmodelFieldDataRangeTypeEnum["Ordinal"] = "DATARANGETYPE_ORDINAL";
    TableauNlpSemanticmodelFieldDataRangeTypeEnum["Nominal"] = "DATARANGETYPE_NOMINAL";
    TableauNlpSemanticmodelFieldDataRangeTypeEnum["Unknown"] = "DATARANGETYPE_UNKNOWN";
})(TableauNlpSemanticmodelFieldDataRangeTypeEnum = exports.TableauNlpSemanticmodelFieldDataRangeTypeEnum || (exports.TableauNlpSemanticmodelFieldDataRangeTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldBinTypeEnum;
(function (TableauNlpSemanticmodelFieldBinTypeEnum) {
    TableauNlpSemanticmodelFieldBinTypeEnum["Unspecified"] = "BINTYPE_UNSPECIFIED";
    TableauNlpSemanticmodelFieldBinTypeEnum["Categorical"] = "BINTYPE_CATEGORICAL";
    TableauNlpSemanticmodelFieldBinTypeEnum["Numeric"] = "BINTYPE_NUMERIC";
    TableauNlpSemanticmodelFieldBinTypeEnum["None"] = "BINTYPE_NONE";
})(TableauNlpSemanticmodelFieldBinTypeEnum = exports.TableauNlpSemanticmodelFieldBinTypeEnum || (exports.TableauNlpSemanticmodelFieldBinTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldErrorCodeEnum;
(function (TableauNlpSemanticmodelFieldErrorCodeEnum) {
    TableauNlpSemanticmodelFieldErrorCodeEnum["UnspecifiedError"] = "UNSPECIFIED_ERROR";
    TableauNlpSemanticmodelFieldErrorCodeEnum["Ok"] = "OK";
    TableauNlpSemanticmodelFieldErrorCodeEnum["InternalError"] = "INTERNAL_ERROR";
    TableauNlpSemanticmodelFieldErrorCodeEnum["CalculatedFieldError"] = "CALCULATED_FIELD_ERROR";
    TableauNlpSemanticmodelFieldErrorCodeEnum["FieldConnectionError"] = "FIELD_CONNECTION_ERROR";
    TableauNlpSemanticmodelFieldErrorCodeEnum["IndexingFailed"] = "INDEXING_FAILED";
})(TableauNlpSemanticmodelFieldErrorCodeEnum = exports.TableauNlpSemanticmodelFieldErrorCodeEnum || (exports.TableauNlpSemanticmodelFieldErrorCodeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum;
(function (TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum) {
    TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum["IndexabilityUnknown"] = "VALUE_INDEXABILITY_UNKNOWN";
    TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum["IndexingUnsupported"] = "VALUE_INDEXING_UNSUPPORTED";
    TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum["IndexingEnabled"] = "VALUE_INDEXING_ENABLED";
    TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum["IndexingDisabled"] = "VALUE_INDEXING_DISABLED";
    TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum["IndexingUnsupportedFieldHasNoValue"] = "VALUE_INDEXING_UNSUPPORTED_FIELD_HAS_NO_VALUE";
})(TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum = exports.TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum || (exports.TableauNlpSemanticmodelFieldValueIndexabilityCodeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpSemanticmodelFieldUnsupportedCodeEnum;
(function (TableauNlpSemanticmodelFieldUnsupportedCodeEnum) {
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["IsSupported"] = "IS_SUPPORTED";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedClusterField"] = "UNSUPPORTED_CLUSTER_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedLatitudeLongitudeField"] = "UNSUPPORTED_LATITUDE_LONGITUDE_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedCombinedField"] = "UNSUPPORTED_COMBINED_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedCombinedSetField"] = "UNSUPPORTED_COMBINED_SET_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedSetField"] = "UNSUPPORTED_SET_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedHierarchyField"] = "UNSUPPORTED_HIERARCHY_FIELD";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedTableCalc"] = "UNSUPPORTED_TABLE_CALC";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedFieldNameOverMaxLength"] = "UNSUPPORTED_FIELD_NAME_OVER_MAX_LENGTH";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedFieldNameUnderMinLength"] = "UNSUPPORTED_FIELD_NAME_UNDER_MIN_LENGTH";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedFieldNameHasInvalidCharacter"] = "UNSUPPORTED_FIELD_NAME_HAS_INVALID_CHARACTER";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedFieldNameIsInvalidDataType"] = "UNSUPPORTED_FIELD_NAME_IS_INVALID_DATA_TYPE";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedFieldNameIsReservedTerm"] = "UNSUPPORTED_FIELD_NAME_IS_RESERVED_TERM";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedAggregationType"] = "UNSUPPORTED_AGGREGATION_TYPE";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedConstParamFormula"] = "UNSUPPORTED_CONST_PARAM_FORMULA";
    TableauNlpSemanticmodelFieldUnsupportedCodeEnum["UnsupportedUnknownFieldType"] = "UNSUPPORTED_UNKNOWN_FIELD_TYPE";
})(TableauNlpSemanticmodelFieldUnsupportedCodeEnum = exports.TableauNlpSemanticmodelFieldUnsupportedCodeEnum || (exports.TableauNlpSemanticmodelFieldUnsupportedCodeEnum = {}));
function TableauNlpSemanticmodelFieldFromJSON(json) {
    return TableauNlpSemanticmodelFieldFromJSONTyped(json, false);
}
exports.TableauNlpSemanticmodelFieldFromJSON = TableauNlpSemanticmodelFieldFromJSON;
function TableauNlpSemanticmodelFieldFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'graphId': !runtime_1.exists(json, 'graph_id') ? undefined : json['graph_id'],
        'label': !runtime_1.exists(json, 'label') ? undefined : json['label'],
        'synonyms': !runtime_1.exists(json, 'synonyms') ? undefined : json['synonyms'],
        'dataType': !runtime_1.exists(json, 'data_type') ? undefined : json['data_type'],
        'fieldType': !runtime_1.exists(json, 'field_type') ? undefined : json['field_type'],
        'fieldRole': !runtime_1.exists(json, 'field_role') ? undefined : json['field_role'],
        'dataRangeType': !runtime_1.exists(json, 'data_range_type') ? undefined : json['data_range_type'],
        'binType': !runtime_1.exists(json, 'bin_type') ? undefined : json['bin_type'],
        'defaultAggregation': !runtime_1.exists(json, 'default_aggregation') ? undefined : _1.TableauNlpSemanticmodelFieldAggregationFromJSON(json['default_aggregation']),
        'isAutoGenerated': !runtime_1.exists(json, 'is_auto_generated') ? undefined : json['is_auto_generated'],
        'formula': !runtime_1.exists(json, 'formula') ? undefined : json['formula'],
        'invalid': !runtime_1.exists(json, 'invalid') ? undefined : json['invalid'],
        'hidden': !runtime_1.exists(json, 'hidden') ? undefined : json['hidden'],
        'popularityScore': !runtime_1.exists(json, 'popularity_score') ? undefined : _1.TableauNlpSemanticmodelFieldNullInt64FromJSON(json['popularity_score']),
        'parentFieldGraphId': !runtime_1.exists(json, 'parent_field_graph_id') ? undefined : json['parent_field_graph_id'],
        'valueAliases': !runtime_1.exists(json, 'value_aliases') ? undefined : json['value_aliases'],
        'numericalValuesMetadata': !runtime_1.exists(json, 'numerical_values_metadata') ? undefined : _1.TableauNlpSemanticmodelFieldNumericalValuesMetadataFromJSON(json['numerical_values_metadata']),
        'dateValuesMetadata': !runtime_1.exists(json, 'date_values_metadata') ? undefined : _1.TableauNlpSemanticmodelFieldDateValuesMetadataFromJSON(json['date_values_metadata']),
        'textValuesMetadata': !runtime_1.exists(json, 'text_values_metadata') ? undefined : _1.TableauNlpSemanticmodelFieldTextValuesMetadataFromJSON(json['text_values_metadata']),
        'numericalDiscreteValuesMetadata': !runtime_1.exists(json, 'numerical_discrete_values_metadata') ? undefined : _1.TableauNlpSemanticmodelFieldNumericalDiscreteValuesMetadataFromJSON(json['numerical_discrete_values_metadata']),
        'booleanValuesMetadata': !runtime_1.exists(json, 'boolean_values_metadata') ? undefined : _1.TableauNlpSemanticmodelFieldBooleanValuesMetadataFromJSON(json['boolean_values_metadata']),
        'parentName': !runtime_1.exists(json, 'parent_name') ? undefined : json['parent_name'],
        'hasUserReference': !runtime_1.exists(json, 'has_user_reference') ? undefined : json['has_user_reference'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'valueConcept': !runtime_1.exists(json, 'value_concept') ? undefined : _1.TableauNlpSemanticmodelFieldValueConceptFromJSON(json['value_concept']),
        'computationInProgress': !runtime_1.exists(json, 'computation_in_progress') ? undefined : json['computation_in_progress'],
        'errorCode': !runtime_1.exists(json, 'error_code') ? undefined : json['error_code'],
        'shouldIndexValue': !runtime_1.exists(json, 'should_index_value') ? undefined : json['should_index_value'],
        'valueIndexabilityCode': !runtime_1.exists(json, 'value_indexability_code') ? undefined : json['value_indexability_code'],
        'unsupportedCode': !runtime_1.exists(json, 'unsupported_code') ? undefined : json['unsupported_code'],
        'tdsServiceFieldUri': !runtime_1.exists(json, 'tds_service_field_uri') ? undefined : json['tds_service_field_uri'],
        'objectName': !runtime_1.exists(json, 'object_name') ? undefined : json['object_name'],
        'schemaCaption': !runtime_1.exists(json, 'schema_caption') ? undefined : json['schema_caption'],
        'fieldConceptKey': !runtime_1.exists(json, 'field_concept_key') ? undefined : json['field_concept_key'],
        'inheritedFieldSynonyms': !runtime_1.exists(json, 'inherited_field_synonyms') ? undefined : json['inherited_field_synonyms'],
        'authoringNameComponents': !runtime_1.exists(json, 'authoring_name_components') ? undefined : json['authoring_name_components'],
        'nestedValueConcept': !runtime_1.exists(json, 'nestedValueConcept') ? undefined : json['nestedValueConcept'],
        'nestedNullInt64': !runtime_1.exists(json, 'nestedNullInt64') ? undefined : json['nestedNullInt64'],
        'nestedAggregation': !runtime_1.exists(json, 'nestedAggregation') ? undefined : json['nestedAggregation'],
        'nestedNumericalValuesMetadata': !runtime_1.exists(json, 'nestedNumericalValuesMetadata') ? undefined : json['nestedNumericalValuesMetadata'],
        'nestedNumericalBin': !runtime_1.exists(json, 'nestedNumericalBin') ? undefined : json['nestedNumericalBin'],
        'nestedNumericalDiscreteValuesMetadata': !runtime_1.exists(json, 'nestedNumericalDiscreteValuesMetadata') ? undefined : json['nestedNumericalDiscreteValuesMetadata'],
        'nestedNumericalDiscreteValue': !runtime_1.exists(json, 'nestedNumericalDiscreteValue') ? undefined : json['nestedNumericalDiscreteValue'],
        'nestedDateValuesMetadata': !runtime_1.exists(json, 'nestedDateValuesMetadata') ? undefined : json['nestedDateValuesMetadata'],
        'nestedTextValue': !runtime_1.exists(json, 'nestedTextValue') ? undefined : json['nestedTextValue'],
        'nestedTextValuesMetadata': !runtime_1.exists(json, 'nestedTextValuesMetadata') ? undefined : json['nestedTextValuesMetadata'],
        'nestedBooleanValuesMetadata': !runtime_1.exists(json, 'nestedBooleanValuesMetadata') ? undefined : json['nestedBooleanValuesMetadata'],
    };
}
exports.TableauNlpSemanticmodelFieldFromJSONTyped = TableauNlpSemanticmodelFieldFromJSONTyped;
function TableauNlpSemanticmodelFieldToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'graph_id': value.graphId,
        'label': value.label,
        'synonyms': value.synonyms,
        'data_type': value.dataType,
        'field_type': value.fieldType,
        'field_role': value.fieldRole,
        'data_range_type': value.dataRangeType,
        'bin_type': value.binType,
        'default_aggregation': _1.TableauNlpSemanticmodelFieldAggregationToJSON(value.defaultAggregation),
        'is_auto_generated': value.isAutoGenerated,
        'formula': value.formula,
        'invalid': value.invalid,
        'hidden': value.hidden,
        'popularity_score': _1.TableauNlpSemanticmodelFieldNullInt64ToJSON(value.popularityScore),
        'parent_field_graph_id': value.parentFieldGraphId,
        'value_aliases': value.valueAliases,
        'numerical_values_metadata': _1.TableauNlpSemanticmodelFieldNumericalValuesMetadataToJSON(value.numericalValuesMetadata),
        'date_values_metadata': _1.TableauNlpSemanticmodelFieldDateValuesMetadataToJSON(value.dateValuesMetadata),
        'text_values_metadata': _1.TableauNlpSemanticmodelFieldTextValuesMetadataToJSON(value.textValuesMetadata),
        'numerical_discrete_values_metadata': _1.TableauNlpSemanticmodelFieldNumericalDiscreteValuesMetadataToJSON(value.numericalDiscreteValuesMetadata),
        'boolean_values_metadata': _1.TableauNlpSemanticmodelFieldBooleanValuesMetadataToJSON(value.booleanValuesMetadata),
        'parent_name': value.parentName,
        'has_user_reference': value.hasUserReference,
        'description': value.description,
        'value_concept': _1.TableauNlpSemanticmodelFieldValueConceptToJSON(value.valueConcept),
        'computation_in_progress': value.computationInProgress,
        'error_code': value.errorCode,
        'should_index_value': value.shouldIndexValue,
        'value_indexability_code': value.valueIndexabilityCode,
        'unsupported_code': value.unsupportedCode,
        'tds_service_field_uri': value.tdsServiceFieldUri,
        'object_name': value.objectName,
        'schema_caption': value.schemaCaption,
        'field_concept_key': value.fieldConceptKey,
        'inherited_field_synonyms': value.inheritedFieldSynonyms,
        'authoring_name_components': value.authoringNameComponents,
        'nestedValueConcept': value.nestedValueConcept,
        'nestedNullInt64': value.nestedNullInt64,
        'nestedAggregation': value.nestedAggregation,
        'nestedNumericalValuesMetadata': value.nestedNumericalValuesMetadata,
        'nestedNumericalBin': value.nestedNumericalBin,
        'nestedNumericalDiscreteValuesMetadata': value.nestedNumericalDiscreteValuesMetadata,
        'nestedNumericalDiscreteValue': value.nestedNumericalDiscreteValue,
        'nestedDateValuesMetadata': value.nestedDateValuesMetadata,
        'nestedTextValue': value.nestedTextValue,
        'nestedTextValuesMetadata': value.nestedTextValuesMetadata,
        'nestedBooleanValuesMetadata': value.nestedBooleanValuesMetadata,
    };
}
exports.TableauNlpSemanticmodelFieldToJSON = TableauNlpSemanticmodelFieldToJSON;
